import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class QuadbinBoundary extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.quadbinboundary',
        group: 'Spatial Indexes',
        title: 'Quadbin Boundary',
        description: `
      This component takes a table with Quadbin cell indices and generates a new one with an
      additional column containing the boundaries of those Quadbin cells.
      `,
        starred: true
      },

      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'quadbincol',
          type: WorkflowComponentParamType.Column,
          title: 'Quadbin column',
          parent: 'source',
          placeholder: 'quadbin',
          dataType: [ColumnDataType.Number]
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    if (connection.type === Provider.DatabricksRest) {
      return `SELECT /*+ REPARTITION(40, ${params.quadbincol}_geo) */
        ${connection.processOutputGeogColumn(`ST_GEOMFROMTEXT(QUADBIN_BOUNDARY(
          ${params.quadbincol}
        ))`)} ${params.quadbincol}_geo, *
      FROM ${connection.quoteName(params.source as string)}`
    } else {
      return `SELECT
              ${connection.quoteName(envVars.analyticsToolboxDataset as string)}.QUADBIN_BOUNDARY(
                  ${params.quadbincol}
                ) ${params.quadbincol}_geo, *
              FROM ${connection.quoteName(params.source as string)}`
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  requiredAnalyticsToolboxVersion(provider: Provider): string | null {
    return '1.0.0'
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params, connection }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.quadbincol}_geo`,
      type: connection.getGeoDataType()
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.Snowflake, Provider.DatabricksRest]
  }
}

export { QuadbinBoundary }
